const origins = [{
    name : 'Austria',
    short : 'at',
    busyStreet : {
        total : 19.1,
        share : [{
            total : 1.8,
            share : [1.8, 0, 0, 0, 0]
        }, {
            total : 6.0,
            share : [0, 0.27, 0.15, 0.86, 4.72]
        }, {
            total : 5.3,
            share : [0, 0.40, 0.51, 0.94, 3.49]
        }, {
            total : 4.4,
            share : [0, 0.41, 2.14, 1.89, 0]
        }, {
            total : 1.6,
            share : [0, 0, 1.56, 0, 0]
        }]
    },
    quietStreet : {
        total : 17.6,
        share : [{
            total : 1.8,
            share : [1.8, 0, 0, 0, 0]
        }, {
            total : 6.0,
            share : [0, 0.27, 0.15, 0.86, 4.72]
        }, {
            total : 5.3,
            share : [0, 0.40, 0.51, 0.94, 3.49]
        }, {
            total : 4.4,
            share : [0, 0.41, 2.14, 1.89, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    },
    ruralArea : {
        total : 13.1,
        share : [{
            total : 1.8,
            share : [1.8, 0, 0, 0, 0]
        }, {
            total : 6.0,
            share : [0, 0.27, 0.15, 0.86, 4.72]
        }, {
            total : 5.3,
            share : [0, 0.40, 0.51, 0.94, 3.49]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    }
}, {
    name : 'Belgium',
    short : 'be',
    busyStreet : {
        total : 20.6,
        share : [{
            total : 1.3,
            share : [1.3, 0, 0, 0, 0]
        }, {
            total : 10.6,
            share : [0, 0.54, 0.69, 0.99, 8.37]
        }, {
            total : 4.5,
            share : [0, 0.20, 0.24, 0.48, 3.54]
        }, {
            total : 3.1,
            share : [0, 0.81, 1.73, 0.60, 0]
        }, {
            total : 1.2,
            share : [0, 0, 1.15, 0, 0]
        }]
    },
    quietStreet : {
        total : 19.5,
        share : [{
            total : 1.3,
            share : [1.3, 0, 0, 0, 0]
        }, {
            total : 10.6,
            share : [0, 0.54, 0.69, 0.99, 8.37]
        }, {
            total : 4.5,
            share : [0, 0.20, 0.24, 0.48, 3.54]
        }, {
            total : 3.1,
            share : [0, 0.81, 1.73, 0.60, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    },
    ruralArea : {
        total : 16.3,
        share : [{
            total : 1.3,
            share : [1.3, 0, 0, 0, 0]
        }, {
            total : 10.6,
            share : [0, 0.54, 0.69, 0.99, 8.37]
        }, {
            total : 4.5,
            share : [0, 0.20, 0.24, 0.48, 3.54]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    }
}, {
    name : 'Bulgaria',
    short : 'bg',
    busyStreet : {
        total : 31.7,
        share : [{
            total : 1.6,
            share : [1.6, 0, 0, 0, 0]
        }, {
            total : 5.1,
            share : [0, 0.41, 0.07, 0.52, 4.07]
        }, {
            total : 9.8,
            share : [0, 0.35, 0.07, 0.52, 8.88]
        }, {
            total : 11.1,
            share : [0, 2.07, 2.34, 6.74, 0]
        }, {
            total : 4.1,
            share : [0, 0, 4.10, 0, 0]
        }]
    },
    quietStreet : {
        total : 27.6,
        share : [{
            total : 1.6,
            share : [1.6, 0, 0, 0, 0]
        }, {
            total : 5.1,
            share : [0, 0.41, 0.07, 0.52, 4.07]
        }, {
            total : 9.8,
            share : [0, 0.35, 0.07, 0.52, 8.88]
        }, {
            total : 11.1,
            share : [0, 2.07, 2.34, 6.74, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    },
    ruralArea : {
        total : 16.5,
        share : [{
            total : 1.6,
            share : [1.6, 0, 0, 0, 0]
        }, {
            total : 5.1,
            share : [0, 0.41, 0.07, 0.52, 4.07]
        }, {
            total : 9.8,
            share : [0, 0.35, 0.07, 0.52, 8.88]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    }
}, {
    name : 'Cyprus',
    short : 'cy',
    busyStreet : {
        total : 0,
        share : [{
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    },
    quietStreet : {
        total : 0,
        share : [{
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    },
    ruralArea : {
        total : 0,
        share : [{
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    }
}, {
    name : 'Czech Republic',
    short : 'cz',
    busyStreet : {
        total : 23.8,
        share : [{
            total : 1.5,
            share : [1.5, 0, 0, 0, 0]
        }, {
            total : 9.0,
            share : [0, 0.53, 0.24, 2.14, 6.07]
        }, {
            total : 7.8,
            share : [0, 0.35, 0.40, 1.95, 5.13]
        }, {
            total : 3.6,
            share : [0, 0.61, 1.04, 1.93, 0]
        }, {
            total : 1.9,
            share : [0, 0, 1.89, 0, 0]
        }]
    },
    quietStreet : {
        total : 21.9,
        share : [{
            total : 1.5,
            share : [1.5, 0, 0, 0, 0]
        }, {
            total : 9.0,
            share : [0, 0.53, 0.24, 2.14, 6.07]
        }, {
            total : 7.8,
            share : [0, 0.35, 0.40, 1.95, 5.13]
        }, {
            total : 3.6,
            share : [0, 0.61, 1.04, 1.93, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    },
    ruralArea : {
        total : 18.3,
        share : [{
            total : 1.5,
            share : [1.5, 0, 0, 0, 0]
        }, {
            total : 9.0,
            share : [0, 0.53, 0.24, 2.14, 6.07]
        }, {
            total : 7.8,
            share : [0, 0.35, 0.40, 1.95, 5.13]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    }
}, {
    name : 'Germany',
    short : 'de',
    busyStreet : {
        total : 18.9,
        share : [{
            total : 1.4,
            share : [1.4, 0, 0, 0, 0]
        }, {
            total : 5.4,
            share : [0, 0.23, 0.20, 0.70, 4.28]
        }, {
            total : 5.7,
            share : [0, 0.24, 0.21, 0.60, 4.66]
        }, {
            total : 3.4,
            share : [0, 1.01, 1.27, 1.08, 0]
        }, {
            total : 3.0,
            share : [0, 0, 3.01, 0, 0]
        }]
    },
    quietStreet : {
        total : 15.9,
        share : [{
            total : 1.4,
            share : [1.4, 0, 0, 0, 0]
        }, {
            total : 5.4,
            share : [0, 0.23, 0.20, 0.70, 4.28]
        }, {
            total : 5.7,
            share : [0, 0.24, 0.21, 0.60, 4.66]
        }, {
            total : 3.4,
            share : [0, 1.01, 1.27, 1.08, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    },
    ruralArea : {
        total : 12.5,
        share : [{
            total : 1.4,
            share : [1.4, 0, 0, 0, 0]
        }, {
            total : 5.4,
            share : [0, 0.23, 0.20, 0.70, 4.28]
        }, {
            total : 5.7,
            share : [0, 0.24, 0.21, 0.60, 4.66]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    }
}, {
    name : 'Denmark',
    short : 'dk',
    busyStreet : {
        total : 0,
        share : [{
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    },
    quietStreet : {
        total : 0,
        share : [{
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    },
    ruralArea : {
        total : 0,
        share : [{
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    }
}, {
    name : 'Estonia',
    short : 'ee',
    busyStreet : {
        total : 10.0,
        share : [{
            total : 0.4,
            share : [0.4, 0, 0, 0, 0]
        }, {
            total : 2.8,
            share : [0, 0.28, 0.11, 0.31, 2.15]
        }, {
            total : 1.9,
            share : [0, 0.27, 0.04, 0.42, 1.13]
        }, {
            total : 3.9,
            share : [0, 1.42, 0.45, 2.02, 0]
        }, {
            total : 1.0,
            share : [0, 0, 0.95, 0, 0]
        }]
    },
    quietStreet : {
        total : 9,
        share : [{
            total : 0.4,
            share : [0.4, 0, 0, 0, 0]
        }, {
            total : 2.8,
            share : [0, 0.28, 0.11, 0.31, 2.15]
        }, {
            total : 1.9,
            share : [0, 0.27, 0.04, 0.42, 1.13]
        }, {
            total : 3.9,
            share : [0, 1.42, 0.45, 2.02, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    },
    ruralArea : {
        total : 5.1,
        share : [{
            total : 0.4,
            share : [0.4, 0, 0, 0, 0]
        }, {
            total : 2.8,
            share : [0, 0.28, 0.11, 0.31, 2.15]
        }, {
            total : 1.9,
            share : [0, 0.27, 0.04, 0.42, 1.13]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    }
}, {
    name : 'Spain',
    short : 'es',
    busyStreet : {
        total : 15.4,
        share : [{
            total : 2.4,
            share : [2.4, 0, 0, 0, 0]
        }, {
            total : 1.7,
            share : [0, 0.10, 0.10, 0.15, 1.30]
        }, {
            total : 5.5,
            share : [0, 0.68, 0.41, 0.42, 4.04]
        }, {
            total : 4.9,
            share : [0, 0.55, 2.65, 1.74, 0]
        }, {
            total : 0.8,
            share : [0, 0, 0.84, 0, 0]
        }]
    },
    quietStreet : {
        total : 14.6,
        share : [{
            total : 2.4,
            share : [2.4, 0, 0, 0, 0]
        }, {
            total : 1.7,
            share : [0, 0.10, 0.10, 0.15, 1.30]
        }, {
            total : 5.5,
            share : [0, 0.68, 0.41, 0.42, 4.04]
        }, {
            total : 4.9,
            share : [0, 0.55, 2.65, 1.74, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    },
    ruralArea : {
        total : 9.6,
        share : [{
            total : 2.4,
            share : [2.4, 0, 0, 0, 0]
        }, {
            total : 1.7,
            share : [0, 0.10, 0.10, 0.15, 1.30]
        }, {
            total : 5.5,
            share : [0, 0.68, 0.41, 0.42, 4.04]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    }
}, {
    name : 'Finland',
    short : 'fi',
    busyStreet : {
        total : 9.3,
        share : [{
            total : 0.2,
            share : [0.2, 0, 0, 0, 0]
        }, {
            total : 5.0,
            share : [0, 0.18, 0.87, 0.25, 3.74]
        }, {
            total : 0.8,
            share : [0, 0.06, 0.04, 0.10, 0.60]
        }, {
            total : 2.4,
            share : [0, 0.09, 1.48, 0.82, 0]
        }, {
            total : 0.9,
            share : [0, 0, 0.95, 0, 0]
        }]
    },
    quietStreet : {
        total : 8.4,
        share : [{
            total : 0.2,
            share : [0.2, 0, 0, 0, 0]
        }, {
            total : 5.0,
            share : [0, 0.18, 0.87, 0.25, 3.74]
        }, {
            total : 0.8,
            share : [0, 0.06, 0.04, 0.10, 0.60]
        }, {
            total : 2.4,
            share : [0, 0.09, 1.48, 0.82, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    },
    ruralArea : {
        total : 6.0,
        share : [{
            total : 0.2,
            share : [0.2, 0, 0, 0, 0]
        }, {
            total : 5.0,
            share : [0, 0.18, 0.87, 0.25, 3.74]
        }, {
            total : 0.8,
            share : [0, 0.06, 0.04, 0.10, 0.60]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    }
}, {
    name : 'France',
    short : 'fr',
    busyStreet : {
        total : 20.1,
        share : [{
            total : 1.7,
            share : [1.7, 0, 0, 0, 0]
        }, {
            total : 3.6,
            share : [0, 0.16, 0.17, 0.30, 3.01]
        }, {
            total : 6.1,
            share : [0, 0.63, 0.48, 1.15, 3.80]
        }, {
            total : 5.9,
            share : [0, 0.71, 2.07, 3.08, 0]
        }, {
            total : 2.8,
            share : [0, 0, 2.78, 0, 0]
        }]
    },
    quietStreet : {
        total : 17.3,
        share : [{
            total : 1.7,
            share : [1.7, 0, 0, 0, 0]
        }, {
            total : 3.6,
            share : [0, 0.16, 0.17, 0.30, 3.01]
        }, {
            total : 6.1,
            share : [0, 0.63, 0.48, 1.15, 3.80]
        }, {
            total : 5.9,
            share : [0, 0.71, 2.07, 3.08, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    },
    ruralArea : {
        total : 11.4,
        share : [{
            total : 1.7,
            share : [1.7, 0, 0, 0, 0]
        }, {
            total : 3.6,
            share : [0, 0.16, 0.17, 0.30, 3.01]
        }, {
            total : 6.1,
            share : [0, 0.63, 0.48, 1.15, 3.80]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    }
}, {
    name : 'United Kingdom',
    short : 'gb',
    busyStreet : {
        total : 15.0,
        share : [{
            total : 1.2,
            share : [1.2, 0, 0, 0, 0]
        }, {
            total : 2.7,
            share : [0, 0.09, 0.16, 0.22, 2.25]
        }, {
            total : 4.5,
            share : [0, 0.23, 0.21, 0.21, 3.82]
        }, {
            total : 4.4,
            share : [0, 1.04, 2.58, 0.77, 0]
        }, {
            total : 2.3,
            share : [0, 0, 2.28, 0, 0]
        }]
    },
    quietStreet : {
        total : 12.8,
        share : [{
            total : 1.2,
            share : [1.2, 0, 0, 0, 0]
        }, {
            total : 2.7,
            share : [0, 0.09, 0.16, 0.22, 2.25]
        }, {
            total : 4.5,
            share : [0, 0.23, 0.21, 0.21, 3.82]
        }, {
            total : 4.4,
            share : [0, 1.04, 2.58, 0.77, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    },
    ruralArea : {
        total : 8.4,
        share : [{
            total : 1.2,
            share : [1.2, 0, 0, 0, 0]
        }, {
            total : 2.7,
            share : [0, 0.09, 0.16, 0.22, 2.25]
        }, {
            total : 4.5,
            share : [0, 0.23, 0.21, 0.21, 3.82]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    }
}, {
    name : 'Greece',
    short : 'gr',
    busyStreet : {
        total : 31.3,
        share : [{
            total : 4.5,
            share : [4.5, 0, 0, 0, 0]
        }, {
            total : 5.5,
            share : [0, 0.27, 0.23, 0.39, 4.64]
        }, {
            total : 6.9,
            share : [0, 1.35, 0.44, 0.66, 4.47]
        }, {
            total : 12.6,
            share : [0, 0.21, 7.83, 4.56, 0]
        }, {
            total : 1.7,
            share : [0, 0, 1.70, 0, 0]
        }]
    },
    quietStreet : {
        total : 29.6,
        share : [{
            total : 4.5,
            share : [4.5, 0, 0, 0, 0]
        }, {
            total : 5.5,
            share : [0, 0.27, 0.23, 0.39, 4.64]
        }, {
            total : 6.9,
            share : [0, 1.35, 0.44, 0.66, 4.47]
        }, {
            total : 12.6,
            share : [0, 0.21, 7.83, 4.56, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    },
    ruralArea : {
        total : 17.0,
        share : [{
            total : 4.5,
            share : [4.5, 0, 0, 0, 0]
        }, {
            total : 5.5,
            share : [0, 0.27, 0.23, 0.39, 4.64]
        }, {
            total : 6.9,
            share : [0, 1.35, 0.44, 0.66, 4.47]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    }
}, {
    name : 'Croatia',
    short : 'hr',
    busyStreet : {
        total : 0,
        share : [{
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    },
    quietStreet : {
        total : 0,
        share : [{
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    },
    ruralArea : {
        total : 0,
        share : [{
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    }
}, {
    name : 'Hungary',
    short : 'hu',
    busyStreet : {
        total : 21.7,
        share : [{
            total : 2.0,
            share : [2.0, 0, 0, 0, 0]
        }, {
            total : 8.6,
            share : [0, 0.58, 0.19, 1.46, 6.35]
        }, {
            total : 6.5,
            share : [0, 0.30, 0.26, 1.29, 4.62]
        }, {
            total : 3.8,
            share : [0, 1.06, 0.81, 1.97, 0]
        }, {
            total : 0.8,
            share : [0, 0, 0.85, 0, 0]
        }]
    },
    quietStreet : {
        total : 20.8,
        share : [{
            total : 2.0,
            share : [2.0, 0, 0, 0, 0]
        }, {
            total : 8.6,
            share : [0, 0.58, 0.19, 1.46, 6.35]
        }, {
            total : 6.5,
            share : [0, 0.30, 0.26, 1.29, 4.62]
        }, {
            total : 3.8,
            share : [0, 1.06, 0.81, 1.97, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    },
    ruralArea : {
        total : 17.0,
        share : [{
            total : 2.0,
            share : [2.0, 0, 0, 0, 0]
        }, {
            total : 8.6,
            share : [0, 0.58, 0.19, 1.46, 6.35]
        }, {
            total : 6.5,
            share : [0, 0.30, 0.26, 1.29, 4.62]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    }
}, {
    name : 'Ireland',
    short : 'ie',
    busyStreet : {
        total : 11.7,
        share : [{
            total : 0.9,
            share : [0.9, 0, 0, 0, 0]
        }, {
            total : 2.2,
            share : [0, 0.06, 0.08, 0.13, 1.95]
        }, {
            total : 1.3,
            share : [0, 0.07, 0.05, 0.27, 0.89]
        }, {
            total : 4.8,
            share : [0, 0.81, 2.65, 1.30, 0]
        }, {
            total : 2.5,
            share : [0, 0, 2.45, 0, 0]
        }]
    },
    quietStreet : {
        total : 9.2,
        share : [{
            total : 0.9,
            share : [0.9, 0, 0, 0, 0]
        }, {
            total : 2.2,
            share : [0, 0.06, 0.08, 0.13, 1.95]
        }, {
            total : 1.3,
            share : [0, 0.07, 0.05, 0.27, 0.89]
        }, {
            total : 4.8,
            share : [0, 0.81, 2.65, 1.30, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    },
    ruralArea : {
        total : 4.4,
        share : [{
            total : 0.9,
            share : [0.9, 0, 0, 0, 0]
        }, {
            total : 2.2,
            share : [0, 0.06, 0.08, 0.13, 1.95]
        }, {
            total : 1.3,
            share : [0, 0.07, 0.05, 0.27, 0.89]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    }
}, {
    name : 'Italy',
    short : 'it',
    busyStreet : {
        total : 22.0,
        share : [{
            total : 2.4,
            share : [2.4, 0, 0, 0, 0]
        }, {
            total : 2.9,
            share : [0, 0.11, 0.09, 0.36, 2.37]
        }, {
            total : 9.1,
            share : [0, 0.54, 0.53, 1.15, 6.85]
        }, {
            total : 5.8,
            share : [0, 0.50, 2.11, 3.22, 0]
        }, {
            total : 1.8,
            share : [0, 0, 1.77, 0, 0]
        }]
    },
    quietStreet : {
        total : 20.2,
        share : [{
            total : 2.4,
            share : [2.4, 0, 0, 0, 0]
        }, {
            total : 2.9,
            share : [0, 0.11, 0.09, 0.36, 2.37]
        }, {
            total : 9.1,
            share : [0, 0.54, 0.53, 1.15, 6.85]
        }, {
            total : 5.8,
            share : [0, 0.50, 2.11, 3.22, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    },
    ruralArea : {
        total : 14.4,
        share : [{
            total : 2.4,
            share : [2.4, 0, 0, 0, 0]
        }, {
            total : 2.9,
            share : [0, 0.11, 0.09, 0.36, 2.37]
        }, {
            total : 9.1,
            share : [0, 0.54, 0.53, 1.15, 6.85]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    }
}, {
    name : 'Lithuania',
    short : 'lt',
    busyStreet : {
        total : 15.6,
        share : [{
            total : 1.2,
            share : [1.2, 0, 0, 0, 0]
        }, {
            total : 6.1,
            share : [0, 0.39, 0.14, 0.92, 4.63]
        }, {
            total : 4.0,
            share : [0, 0.21, 0.13, 0.85, 2.83]
        }, {
            total : 4.1,
            share : [0, 0.64, 1.20, 2.22, 0]
        }, {
            total : 0.3,
            share : [0, 0, 0.29, 0, 0]
        }]
    },
    quietStreet : {
        total : 15.3,
        share : [{
            total : 1.2,
            share : [1.2, 0, 0, 0, 0]
        }, {
            total : 6.1,
            share : [0, 0.39, 0.14, 0.92, 4.63]
        }, {
            total : 4.0,
            share : [0, 0.21, 0.13, 0.85, 2.83]
        }, {
            total : 4.1,
            share : [0, 0.64, 1.20, 2.22, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    },
    ruralArea : {
        total : 11.3,
        share : [{
            total : 1.2,
            share : [1.2, 0, 0, 0, 0]
        }, {
            total : 6.1,
            share : [0, 0.39, 0.14, 0.92, 4.63]
        }, {
            total : 4.0,
            share : [0, 0.21, 0.13, 0.85, 2.83]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    }

}, {
    name : 'Luxembourg',
    short : 'lu',
    busyStreet : {
        total : 0,
        share : [{
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    },
    quietStreet : {
        total : 0,
        share : [{
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    },
    ruralArea : {
        total : 0,
        share : [{
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    }

}, {
    name : 'Latvia',
    short : 'lt',
    busyStreet : {
        total : 0,
        share : [{
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    },
    quietStreet : {
        total : 0,
        share : [{
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    },
    ruralArea : {
        total : 0,
        share : [{
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    },

}, {
    name : 'Malta',
    short : 'mt',
    busyStreet : {
        total : 22.5,
        share : [{
            total : 9.6,
            share : [9.6, 0, 0, 0, 0]
        }, {
            total : 1.6,
            share : [0, 0.04, 0.19, 0.09, 1.32]
        }, {
            total : 0.3,
            share : [0, 0.02, 0.01, 0.00, 0.28]
        }, {
            total : 0.2,
            share : [0, 0.00, 0.18, 0.00, 0]
        }, {
            total : 10.7,
            share : [0, 0, 10.7, 0, 0]
        }]
    },
    quietStreet : {
        total : 11.8,
        share : [{
            total : 9.6,
            share : [9.6, 0, 0, 0, 0]
        }, {
            total : 1.6,
            share : [0, 0.04, 0.19, 0.09, 1.32]
        }, {
            total : 0.3,
            share : [0, 0.02, 0.01, 0.00, 0.28]
        }, {
            total : 0.2,
            share : [0, 0.00, 0.18, 0.00, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    },
    ruralArea : {
        total : 11.6,
        share : [{
            total : 9.6,
            share : [9.6, 0, 0, 0, 0]
        }, {
            total : 1.6,
            share : [0, 0.04, 0.19, 0.09, 1.32]
        }, {
            total : 0.3,
            share : [0, 0.02, 0.01, 0.00, 0.28]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    }

}, {
    name : 'Netherlands',
    short : 'nl',
    busyStreet : {
        total : 18.0,
        share : [{
            total : 1.5,
            share : [1.5, 0, 0, 0, 0]
        }, {
            total : 9.9,
            share : [0, 0.57, 0.69, 0.91, 7.74]
        }, {
            total : 3.5,
            share : [0, 0.51, 0.72, 0.31, 1.97]
        }, {
            total : 1.7,
            share : [0, 0.23, 1.14, 0.31, 0]
        }, {
            total : 1.4,
            share : [0, 0, 1.42, 0, 0]
        }]
    },
    quietStreet : {
        total : 16.6,
        share : [{
            total : 1.5,
            share : [1.5, 0, 0, 0, 0]
        }, {
            total : 9.9,
            share : [0, 0.57, 0.69, 0.91, 7.74]
        }, {
            total : 3.5,
            share : [0, 0.51, 0.72, 0.31, 1.97]
        }, {
            total : 1.7,
            share : [0, 0.23, 1.14, 0.31, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    },
    ruralArea : {
        total : 14.9,
        share : [{
            total : 1.5,
            share : [1.5, 0, 0, 0, 0]
        }, {
            total : 9.9,
            share : [0, 0.57, 0.69, 0.91, 7.74]
        }, {
            total : 3.5,
            share : [0, 0.51, 0.72, 0.31, 1.97]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    }

}, {
    name : 'Poland',
    short : 'pl',
    busyStreet : {
        total : 28.2,
        share : [{
            total : 1.3,
            share : [1.3, 0, 0, 0, 0]
        }, {
            total : 5.2,
            share : [0, 0.35, 0.16, 0.55, 4.11]
        }, {
            total : 9.8,
            share : [0, 0.38, 0.21, 3.32, 5.84]
        }, {
            total : 8.4,
            share : [0, 0.87, 1.10, 6.46, 0]
        }, {
            total : 3.5,
            share : [0, 0, 3.48, 0, 0]
        }]
    },
    quietStreet : {
        total : 24.7,
        share : [{
            total : 1.3,
            share : [1.3, 0, 0, 0, 0]
        }, {
            total : 5.2,
            share : [0, 0.35, 0.16, 0.55, 4.11]
        }, {
            total : 9.8,
            share : [0, 0.38, 0.21, 3.32, 5.84]
        }, {
            total : 8.4,
            share : [0, 0.87, 1.10, 6.46, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    },
    ruralArea : {
        total : 16.3,
        share : [{
            total : 1.3,
            share : [1.3, 0, 0, 0, 0]
        }, {
            total : 5.2,
            share : [0, 0.35, 0.16, 0.55, 4.11]
        }, {
            total : 9.8,
            share : [0, 0.38, 0.21, 3.32, 5.84]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    }

}, {
    name : 'Portugal',
    short : 'pt',
    busyStreet : {
        total : 14.7,
        share : [{
            total : 1.5,
            share : [1.5, 0, 0, 0, 0]
        }, {
            total : 2.3,
            share : [0, 0.11, 0.08, 0.13, 1.96]
        }, {
            total : 4.2,
            share : [0, 1.13, 0.27, 0.60, 2.24]
        }, {
            total : 4.8,
            share : [0, 0.78, 1.91, 2.10, 0]
        }, {
            total : 1.8,
            share : [0, 0, 1.81, 0, 0]
        }]
    },
    quietStreet : {
        total : 12.8,
        share : [{
            total : 1.5,
            share : [1.5, 0, 0, 0, 0]
        }, {
            total : 2.3,
            share : [0, 0.11, 0.08, 0.13, 1.96]
        }, {
            total : 4.2,
            share : [0, 1.13, 0.27, 0.60, 2.24]
        }, {
            total : 4.8,
            share : [0, 0.78, 1.91, 2.10, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    },
    ruralArea : {
        total : 8.1,
        share : [{
            total : 1.5,
            share : [1.5, 0, 0, 0, 0]
        }, {
            total : 2.3,
            share : [0, 0.11, 0.08, 0.13, 1.96]
        }, {
            total : 4.2,
            share : [0, 1.13, 0.27, 0.60, 2.24]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    }

}, {
    name : 'Romania',
    short : 'ro',
    busyStreet : {
        total : 22.7,
        share : [{
            total : 1.5,
            share : [1.5, 0, 0, 0, 0]
        }, {
            total : 4.3,
            share : [0, 0.31, 0.06, 0.53, 3.44]
        }, {
            total : 8.6,
            share : [0, 0.91, 0.15, 1.53, 6.05]
        }, {
            total : 8.2,
            share : [0, 0.05, 0.99, 7.17, 0]
        }, {
            total : 0.0,
            share : [0, 0, 0, 0, 0]
        }]
    },
    quietStreet : {
        total : 22.7,
        share : [{
            total : 1.5,
            share : [1.5, 0, 0, 0, 0]
        }, {
            total : 4.3,
            share : [0, 0.31, 0.06, 0.53, 3.44]
        }, {
            total : 8.6,
            share : [0, 0.91, 0.15, 1.53, 6.05]
        }, {
            total : 8.2,
            share : [0, 0.05, 0.99, 7.17, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    },
    ruralArea : {
        total : 14.5,
        share : [{
            total : 1.5,
            share : [1.5, 0, 0, 0, 0]
        }, {
            total : 4.3,
            share : [0, 0.31, 0.06, 0.53, 3.44]
        }, {
            total : 8.6,
            share : [0, 0.91, 0.15, 1.53, 6.05]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    }

}, {
    name : 'Sweden',
    short : 'se',
    busyStreet : {
        total : 9.9,
        share : [{
            total : 0.4,
            share : [0.4, 0, 0, 0, 0]
        }, {
            total : 4.1,
            share : [0, 0.13, 0.34, 0.38, 3.28]
        }, {
            total : 0.9,
            share : [0, 0.18, 0.09, 0.08, 0.57]
        }, {
            total : 2.7,
            share : [0, 0.36, 1.72, 0.63, 0]
        }, {
            total : 1.8,
            share : [0, 0, 1.77, 0, 0]
        }]
    },
    quietStreet : {
        total : 8.2,
        share : [{
            total : 0.4,
            share : [0.4, 0, 0, 0, 0]
        }, {
            total : 4.1,
            share : [0, 0.13, 0.34, 0.38, 3.28]
        }, {
            total : 0.9,
            share : [0, 0.18, 0.09, 0.08, 0.57]
        }, {
            total : 2.7,
            share : [0, 0.36, 1.72, 0.63, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    },
    ruralArea : {
        total : 5.5,
        share : [{
            total : 0.4,
            share : [0.4, 0, 0, 0, 0]
        }, {
            total : 4.1,
            share : [0, 0.13, 0.34, 0.38, 3.28]
        }, {
            total : 0.9,
            share : [0, 0.18, 0.09, 0.08, 0.57]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    }

}, {
    name : 'Slovenia',
    short : 'si',
    busyStreet : {
        total : 0,
        share : [{
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    },
    quietStreet : {
        total : 0,
        share : [{
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    },
    ruralArea : {
        total : 0,
        share : [{
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    }

}, {
    name : 'Slovakia',
    short : 'sk',
    busyStreet : {
        total : 25.3,
        share : [{
            total : 1.7,
            share : [1.7, 0, 0, 0, 0]
        }, {
            total : 7.7,
            share : [0, 0.50, 0.18, 1.47, 5.60]
        }, {
            total : 6.9,
            share : [0, 0.29, 0.19, 1.76, 4.62]
        }, {
            total : 6.1,
            share : [0, 0.83, 0.56, 4.71, 0]
        }, {
            total : 2.9,
            share : [0, 0, 2.87, 0, 0]
        }]
    },
    quietStreet : {
        total : 22.5,
        share : [{
            total : 1.7,
            share : [1.7, 0, 0, 0, 0]
        }, {
            total : 7.7,
            share : [0, 0.50, 0.18, 1.47, 5.60]
        }, {
            total : 6.9,
            share : [0, 0.29, 0.19, 1.76, 4.62]
        }, {
            total : 6.1,
            share : [0, 0.83, 0.56, 4.71, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    },
    ruralArea : {
        total : 16.3,
        share : [{
            total : 1.7,
            share : [1.7, 0, 0, 0, 0]
        }, {
            total : 7.7,
            share : [0, 0.50, 0.18, 1.47, 5.60]
        }, {
            total : 6.9,
            share : [0, 0.29, 0.19, 1.76, 4.62]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }, {
            total : 0,
            share : [0, 0, 0, 0, 0]
        }]
    }
}];

export default origins;